import React, { useState, useEffect } from 'react'
import { AiOutlineAppstoreAdd, AiFillDelete } from 'react-icons/ai'
import { MdDone } from 'react-icons/md'
import { IoMdAddCircleOutline } from 'react-icons/io'
import axios from "axios";
import Swal from 'sweetalert2'
import ThingsList from './ThingsList';
import { ipAddress } from '../../ipAddress';



interface Props {
  shop: Shops;

}
interface Shops {
  id: number,
  name: string,
  date: string,
  isDone: number,
}
interface Things {
  id: number,
  whatBuy: string,
  endDate: string,
  startDate: string,
  isDone: number,
  price: number,
}

export const SingleShop: React.FC<Props> = ({ shop }) => {
  const [addOption, setAddOption] = useState<boolean>(false);
  const [addThing, setAddThing] = useState<boolean>(false);
  const [promotion, setPromotion] = useState<boolean>(false);
  const [whatBuy, setWhatBuy] = useState<string>("");
  const [price, setPrice] = useState<string>('');
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [thingsList, setThingsList] = useState<Things[]>([]);
  const [visibleList, setVisibleList] = useState<boolean>(false);
  const [allThings, setAllThings] = useState<number>(0)

  const handleAdd = () => {
    setAddThing(!addThing);
  }

  const handleAddOptions = () => {
    setAddOption(true);
  }
  const handleDelete = (id: number) => {
    setAddOption(false)
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie na zawsze usunięty!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + "/deleteShop", {
          id: id,
        })

        axios.post(ipAddress + "/deleteAllThings", {
          shopId: id,
        })
      }
    })
  }



  const handleDone = (id: number) => {
    setAddOption(false)
    let month = new Date().getMonth() + 1;
    let day = new Date().getDate();
    let year = new Date().getFullYear();
    let date = `${month}/${day}/${year}`;

    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie przeniesiony do kupionych",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, move it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + "/doneShop", {
          id: id,
          isDone: 1,
          date: date,


        })

      }
    })

      .then((response) => {

      })

      .catch(function (error) {
        console.log("error!")

      })

  }


  const confirm = (e: React.FormEvent, id: number) => {
    e.preventDefault();
    axios.post(ipAddress + '/thingsList', {
      whatBuy: whatBuy,
      price: price,
      startDate: startDate,
      endDate: endDate,
      isDone: 0,
      id: Math.random(),
      shopId: id,
    })
      .then((response) => {
        console.log(response)
      })
      .catch((err) => {
        console.log(err)
      })
    setWhatBuy('');
    setPrice('');
    setStartDate('');
    setEndDate('');
    setAddThing(false);
    setPromotion(false);
    setVisibleList(true);
  }


  const getThingsList = () => {

    axios.post(ipAddress + "/getThingsList", {
      shopId: shop.id
    })
      .then((response) => {
        setThingsList(response.data)

      })
      .catch((err) => {
        console.log(err)
      })

  }
  useEffect(() => {
    getThingsList();


  }, [thingsList])





  const cancel = () => {
    setAddThing(false)
    setPromotion(false)
  }

  const promotionAdd = () => {
    setPromotion(!promotion)
  }


  return (
    <div >
      <div className='allShops'>
        <span id='name' onClick={() => setVisibleList(!visibleList)}>{shop.name}  {thingsList.length} </span>
        <span className='icon1' onClick={() => handleAdd()} ><IoMdAddCircleOutline /></span>
        <span className='icon2' onClick={() => handleAddOptions()} ><AiOutlineAppstoreAdd /></span>


        {addOption ? (
          <div className='addOption'>
            <p>{shop.name}</p>
            <p onClick={() => handleDone(shop.id)} ><MdDone /><span>Zakończ</span></p>
            <p onClick={() => handleDelete(shop.id)} ><AiFillDelete /><span>Usuń</span></p>
            <button onClick={() => setAddOption(false)}>Cancel</button>
          </div>

        ) : (
          <div></div>
        )
        }
      </div>
      {addThing ? (
          <form  className='addThing' onSubmit={(e) => { confirm(e, shop.id) }}>
            <button className='icon' id='close' onClick={() => cancel()} >X</button>
            <p id='shopName'>{shop.name}</p>
            <p>Dodaj koszt</p>
            <div className='thingToBuy'>
              <label htmlFor="thing">Nazwa: </label>
              <input type="text" placeholder='Co kupić ?' required
                value={whatBuy}
                onChange={(e) => (setWhatBuy(e.target.value))}
              ></input>
            </div>
            <div className='addPrice'>
              <label htmlFor="add">Kwota: </label>
              <input type="number" placeholder='PLN'
                value={price}
                onChange={(e) => (setPrice(e.target.value))}
              ></input>
            </div>
            <span id='promotion'>Promocja</span>
            <input id='checkbox' type='checkbox' checked={promotion} onChange={() => promotionAdd()}></input>

            {promotion ? (
              <div>
                <div className='addStartDate'>
                <label htmlFor="edit">Od: </label>
                    <input type='date' value={startDate} onChange={(e) => (setStartDate(e.target.value))}></input>
                </div>
                <div className='addEndDate'>
                <label htmlFor="edit">Do: </label>
                    <input type='date' value={endDate} onChange={(e) => (setEndDate(e.target.value))} ></input>
                </div>
              </div>
            ) :
              (
                <div></div>
              )
            }
            <div className='newLine'>
              <button type='submit' id='submit' >OK</button>

            </div>
          </form>
        
      ) :
        (
          <div></div>
        )
      }
      <div>
        {
          visibleList ? (
            thingsList.map((thing) => (
              <ThingsList thing={thing} key={thing.id} shop={shop} />
            ))

          ) : (
            <div></div>
          )
        }


      </div>

    </div>
  )
}
